import api from "./api/api";

const REPORT_AUDIT_LOG_API = '/api/report-audit-log';

// Get audit history for a specific report
export const getReportAuditHistory = async (reportSubscriptionId, page = 1, limit = 50) => {
    try {
        const response = await api.get(`${REPORT_AUDIT_LOG_API}/${reportSubscriptionId}/history`, {
            params: { page, limit }
        });
        return response;
    } catch (error) {
        console.error('Error getting audit history:', error);
        throw error;
    }
};

// Get audit summary for a specific report
export const getReportAuditSummary = async (reportSubscriptionId) => {
    try {
        const response = await api.get(`${REPORT_AUDIT_LOG_API}/${reportSubscriptionId}/summary`);
        return response;
    } catch (error) {
        console.error('Error getting audit summary:', error);
        throw error;
    }
}; 